import { render, staticRenderFns } from "./VSignup.vue?vue&type=template&id=8c28db2c&"
import script from "./VSignup.vue?vue&type=script&lang=js&"
export * from "./VSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports